import A_none from '../../../../../assets/guardrails/A_none.png';
import A_orange from '../../../../../assets/guardrails/A_orange.png';
import A_red from '../../../../../assets/guardrails/A_red.png';
import A_red_orange from '../../../../../assets/guardrails/A_red_orange.png';
import A_red_white from '../../../../../assets/guardrails/A_red_white.png';
import A_white from '../../../../../assets/guardrails/A_white.png';
import A_yellow from '../../../../../assets/guardrails/A_yellow.png';
import AB_none from '../../../../../assets/guardrails/AB_none.png';
import AB_red from '../../../../../assets/guardrails/AB_red.png';
import B_none from '../../../../../assets/guardrails/B_none.png';
import B_red from '../../../../../assets/guardrails/B_red.png';
import Bthin_red from '../../../../../assets/guardrails/Bthin_red.png';

export const GUARDRAILS: string[] = [
    A_none, // 0
    A_orange, // 1
    A_red, // 2
    A_red_orange, // 3
    A_red_white, // 4
    A_white, // 5
    A_yellow, // 6
    AB_none, // 7
    AB_red, // 8
    B_none, // 9
    B_red, // 10
    Bthin_red // 11
];

export const COUNTRY_INDEX_TO_GUARDRAIL_INDEX: number[][] = [
    [2], // Albania
    [10], // Bosnia and Herzegovina
    [2], // Bulgaria
    [2], // Cyprus
    [9], // Denmark
    [7], // Ireland
    [0], // Estonia
    [2], // Austria
    [11], // Czech Republic
    [0], // Finland
    [5], // France
    [2], // Georgia
    [7], // Germany
    [2], // Greece
    [10], // Croatia
    [2], // Hungary
    [5], // Iceland
    [3], // Italy
    [4], // Latvia
    [2], // Belarus
    [1], // Lithuania
    [11], // Slovakia
    [], // Liechtenstein
    [2], // North Macedonia
    [3], // Malta
    [6], // Belgium
    [], // Faroe Islands
    [6], // Andorra
    [5], // Luxembourg
    [], // Monaco
    [8], // Montenegro
    [0], // Netherlands
    [0], // Norway
    [10], // Poland
    [0], // Portugal
    [2], // Romania
    [0], // Republic of Moldova
    [2], // Slovenia
    [6], // Spain
    [5], // Sweden
    [0], // Switzerland
    [8], // Turkey
    [0], // United Kingdom
    [2], // Ukraine
    [3], // San Marino
    [10], // Serbia
    [], // Holy See (Vatican City)
    [2], // Russia
];
